import React from 'react';
import { Children, Heading, TextBlock } from 'neon-design-system';
import { Box } from '@material-ui/core';

interface SectionHeaderWithPreloaderProps {
	id?: string;
	title: string;
	subtitle?: Children;
	large?: boolean;
}

const SectionHeaderSmall = (props: SectionHeaderWithPreloaderProps): JSX.Element => {
	const { title, subtitle, id, large } = props;

	return (
		<Box id={id} mb={1}>
			<Box display="flex" justifyContent="space-between">
				<Heading styleName={large ? 'largeTitle' : 'title1'}>
					{title}
				</Heading>
			</Box>
			{
				subtitle && (
					<TextBlock ink="muted">
						{subtitle}
					</TextBlock>
				)
			}
		</Box>
	);
};

export default SectionHeaderSmall;
